import {gql} from "apollo-boost";

export const AffiliateQuery = gql`
    query Affiliate($institutionId: Int!, $scheduleId :Int!){
        affiliation(institutionId:$institutionId, scheduleId:$scheduleId) {
            documentType
            documentNumber
            name
            lastName
            beneficiaries {
                documentType
                documentNumber
                name
                lastName
                birthDate
                age
            }
        }
    }
`;

export const AffiliateQueryBac = gql`
    {
        bacAffiliation{
            documentType
            documentNumber
            name
            lastName
            birthDate
            status
            beneficiaries{
                documentType
                documentNumber
                name
                lastName
                birthDate
                age
                status
            }
        }
    }
`
